/* VIPet Store — carry the box finder's answers onto the order.

   The finder stores its three answers in sessionStorage. On a product page we
   attach them to the add-to-cart form as line item properties, so they show up
   per line on the order and on the packing slip.

   Deliberate rule: the answers are attached ONLY when the product being viewed
   is the one the finder actually recommended. If the customer wanders off and
   buys a different box, nothing is attached — better no data than wrong data. */
(function () {
  var KEY = 'vipetFinder';
  var MAX_AGE = 2 * 60 * 60 * 1000; /* 2 hours — stale answers are worse than none */

  function read() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var saved = JSON.parse(raw);
      if (!saved || !saved.path) return null;
      if (Date.now() - (saved.ts || 0) > MAX_AGE) return null;
      return saved;
    } catch (e) {
      return null;
    }
  }

  function normalise(path) {
    try { return decodeURIComponent(path).replace(/\/+$/, ''); }
    catch (e) { return String(path).replace(/\/+$/, ''); }
  }

  function attach() {
    var saved = read();
    if (!saved) return;
    if (normalise(window.location.pathname) !== normalise(saved.path)) return;

    var pairs = [
      ['גזע', saved.breed],
      ['משקל', saved.weight],
      ['עוצמת לעיסה', saved.chew]
    ];

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var f = 0; f < forms.length; f++) {
      var form = forms[f];
      /* skip the payment-terms form, which shares the same action */
      if (!form.querySelector('[name="add"]')) continue;

      for (var i = 0; i < pairs.length; i++) {
        var label = pairs[i][0];
        var value = pairs[i][1];
        if (!value) continue;

        var name = 'properties[' + label + ']';
        if (form.querySelector('input[name="' + name + '"]')) continue;

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
